"use client";

import Image from 'next/image';
import { Link } from '@/i18n/navigation';
import { urlFor } from '@/lib/image';
import { useEffect, useState } from 'react';
import { RetrievedBlogPostsListItem } from '@/lib/sanity/responseTypes';

import ArrowRight from "@/components/icons/arrow-right.svg";

interface ArticlesCarouselProps {
  articles: RetrievedBlogPostsListItem[];
}

function ArticlesCarousel(props: ArticlesCarouselProps) {
  const { articles } = props;
  const [articleIndex, setArticleIndex] = useState<number>(0);
  const [article, setArticle] = useState<any>(articles[0]);
  const [hasOlderArticle, setHasOlderArticle] = useState<boolean>(true);
  const [hasNewerArticle, setHasNewerArticle] = useState<boolean>(false);

  useEffect(() => {
    setArticle(articles[articleIndex]);
    setHasOlderArticle(articleIndex < articles.length - 1);
    setHasNewerArticle(articleIndex > 0);
  }, [articleIndex]);

  function olderArticle() {
    let nextArticleIndex = (articleIndex + 1) % articles.length;
    setArticleIndex(nextArticleIndex);
  }

  function newerArticle() {
    let previousArticleIndex = articleIndex - 1;
    if (previousArticleIndex < 0) {
      previousArticleIndex = articles.length - 1;
    }
    setArticleIndex(previousArticleIndex);
  }

  function CarouselItem(article: any, show: boolean) {
    return (
      <div key={article.slug} className={"w-full h-full bg-cover bg-center" + (!show ? " hidden" : "")} style={{ backgroundImage: `url(${article.imageUrl})` }}>
        <div onClick={newerArticle} className="hover:bg-transparent hover:outline-0 cursor-pointer btn-primary absolute top-[50%] left-[2%] p-1 rounded-full h-[36px] box-content transition hover:scale-110">
          <ArrowRight className="h-9 w-9 rotate-180 stroke-primary" />
        </div>
        <div onClick={olderArticle} className="hover:bg-transparent hover:outline-0 cursor-pointer btn-primary absolute top-[50%] right-[2%] p-1 rounded-full h-[36px] box-content transition hover:scale-110">
          <ArrowRight className="h-9 w-9 fill-primary stroke-primary" />
        </div>
        <div className="w-[100%] py-0 px-[30px] justify-center items-center flex absolute top-[60%]">
          <div className="flex-1 flex-col bg-[rgba(255,255,255,0.8)] px-6 py-4 gap-4 transition hover:scale-103">
            <div className="leading-[120%] font-extrabold items-stretch md:text-[40px] text-[30px] shrink-0 text-primary">
              <Link href={`/blog/beitrag/${article.slug}`} >
                {article.title}
              </Link>
            </div>
            <div className="leading-[120%] font-semibold items-stretch md:text-[20px] text-[14px] shink-0 text-primary">
              <Link href={`/blog/beitrag/${article.slug}`} >
                {article.intro}
              </Link>
            </div>
          </div>
        </div>
      </div>);
  }

  return (
    <div className="w-[100%] h-[calc(100vh_-_77px)]">
      {articles.map((a, i) => CarouselItem(a, i == articleIndex))}
    </div>
  )
}

export default ArticlesCarousel;
